var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card-actions",
        {
          attrs: {
            "show-loading": _vm.saving || _vm.fetching,
            "action-collapse": "",
            "action-refresh": "",
            title: _vm.$t("Lançamentos da Conciliação"),
          },
          on: { refresh: _vm.getData },
        },
        [
          _c(
            "div",
            { attrs: { slot: "title" }, slot: "title" },
            [
              _c("e-page-size-selector", {
                attrs: { "per-page": _vm.paging.pageSize },
                on: { change: _vm.pageSizeChange },
              }),
            ],
            1
          ),
          _c(
            "e-filters",
            {
              staticClass: "mb-2 card-bordered",
              attrs: {
                "search-text": _vm.$t("Filtrar"),
                searching: _vm.fetching,
                title: _vm.$t("Filtrar Lançamentos"),
              },
              on: { search: _vm.getData, reset: _vm.resetFiltersLocal },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "filters-status",
                          type: "vue-select",
                          label: _vm.$t("Status"),
                          placeholder: _vm.$t("Todos"),
                          options: _vm.statusReconciliationItemOptions,
                        },
                        model: {
                          value: _vm.filters.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "status", $$v)
                          },
                          expression: "filters.status",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "filters-input-method",
                          type: "vue-select",
                          label: _vm.$t("Forma de associação"),
                          placeholder: _vm.$t("Todas"),
                          options: _vm.inputMethodReconciliationOptions,
                        },
                        model: {
                          value: _vm.filters.inputMethod,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "inputMethod", $$v)
                          },
                          expression: "filters.inputMethod",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "filters-value",
                          type: "text-number",
                          currency: "R$",
                          precision: 2,
                          label: _vm.$t("Valor Santander"),
                          placeholder: _vm.$t("Valor"),
                        },
                        model: {
                          value: _vm.filters.value,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "value", $$v)
                          },
                          expression: "filters.value",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("b-table", {
            ref: "conciliation-items-table",
            staticClass: "bordered",
            attrs: {
              "show-empty": "",
              responsive: "",
              striped: "",
              "empty-text": _vm.getEmptyTableMessage(
                _vm.$tc("RECONCILIATION_ITEM.NAME"),
                "male"
              ),
              fields: _vm.fields,
              items: _vm.conciliationItems,
              "tbody-tr-class": _vm.rowClass,
              "no-local-sorting": "",
              "sort-by": _vm.sorting.sortBy,
              "sort-desc": _vm.sorting.sortDesc,
            },
            on: {
              "update:sortBy": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sort-by": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sortDesc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "update:sort-desc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "sort-changed": _vm.getData,
            },
            scopedSlots: _vm._u([
              {
                key: "thead-top",
                fn: function () {
                  return [
                    _c(
                      "b-tr",
                      [
                        _c("b-th"),
                        _c(
                          "b-th",
                          { attrs: { variant: "primary", colspan: "4" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("Transação Santander")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "b-th",
                          { attrs: { variant: "primary", colspan: "4" } },
                          [_vm._v(" " + _vm._s(_vm.$t("Transação ERP")) + " ")]
                        ),
                        _c("b-th", { attrs: { colspan: "2" } }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "cell(payerName)",
                fn: function (row) {
                  return [
                    _c(
                      "span",
                      {
                        attrs: {
                          title:
                            row.item.payerDocument + " - " + row.item.payerName,
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              row.item.payerDocument != null
                                ? row.item.payerDocument +
                                    " - " +
                                    row.item.payerName
                                : row.item.payerName != null
                                ? row.item.payerName
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(movementDate)",
                fn: function (row) {
                  return [
                    _c(
                      "span",
                      {
                        attrs: {
                          title: _vm.$options.filters.datetime(
                            row.item.movementDate
                          ),
                        },
                      },
                      [_vm._v(_vm._s(_vm._f("time")(row.item.movementDate)))]
                    ),
                  ]
                },
              },
              {
                key: "cell(receivableInstallmentNsu)",
                fn: function (row) {
                  return [
                    !row.item.receivableInstallments ||
                    !row.item.receivableInstallments.length
                      ? _c("span", [_vm._v("-")])
                      : _vm._e(),
                    _vm._l(
                      row.item.receivableInstallments,
                      function (rec, index) {
                        return _c(
                          "div",
                          { key: "receivableNsu-" + row.item.id + "-" + index },
                          [_vm._v(" " + _vm._s(rec.receivable.nsu) + " ")]
                        )
                      }
                    ),
                  ]
                },
              },
              {
                key: "cell(receivableInstallmentSaleId)",
                fn: function (row) {
                  return [
                    !row.item.receivableInstallments ||
                    !row.item.receivableInstallments.length
                      ? _c("span", [_vm._v("-")])
                      : _vm._e(),
                    _vm._l(
                      row.item.receivableInstallments,
                      function (rec, index) {
                        return _c(
                          "div",
                          {
                            key:
                              "receivableSaleId-" + row.item.id + "-" + index,
                          },
                          [
                            rec.receivable.saleId
                              ? _c("e-router-link", {
                                  attrs: {
                                    title: _vm.$t("Visualizar venda"),
                                    to: {
                                      name: "order-read-only",
                                      params: { id: rec.receivable.saleId },
                                    },
                                    value: rec.receivable.saleId,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }
                    ),
                  ]
                },
              },
              {
                key: "cell(receivableInstallmentValue)",
                fn: function (row) {
                  return [
                    !row.item.receivableInstallments ||
                    !row.item.receivableInstallments.length
                      ? _c("span", [_vm._v("-")])
                      : _vm._e(),
                    _vm._l(
                      row.item.receivableInstallments,
                      function (rec, index) {
                        return _c(
                          "div",
                          {
                            key:
                              "receivableSaleVale-" + row.item.id + "-" + index,
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm._f("currency")(rec.value)) + " "
                            ),
                          ]
                        )
                      }
                    ),
                  ]
                },
              },
              {
                key: "cell(receivableDate)",
                fn: function (row) {
                  return [
                    !row.item.receivableInstallments ||
                    !row.item.receivableInstallments.length
                      ? _c("span", [_vm._v("-")])
                      : _vm._e(),
                    _vm._l(
                      row.item.receivableInstallments,
                      function (rec, index) {
                        return _c(
                          "div",
                          {
                            key: "receivableDate-" + row.item.id + "-" + index,
                            attrs: {
                              title: _vm.$options.filters.datetime(
                                rec.receivable.createdDate
                              ),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("time")(rec.receivable.createdDate)
                                ) +
                                " "
                            ),
                          ]
                        )
                      }
                    ),
                  ]
                },
              },
              {
                key: "cell(action)",
                fn: function (row) {
                  return [
                    _c("e-grid-actions", {
                      attrs: {
                        "show-update": false,
                        "show-delete": false,
                        buttons: _vm.buttons(row.item),
                      },
                      on: {
                        match: function ($event) {
                          return _vm.onMatch(row.item)
                        },
                        unmatch: function ($event) {
                          return _vm.onUnmatch(row.item)
                        },
                        skip: function ($event) {
                          return _vm.onSkip(row.item)
                        },
                        reset: function ($event) {
                          return _vm.onReset(row.item)
                        },
                      },
                    }),
                  ]
                },
              },
              {
                key: "custom-foot",
                fn: function () {
                  return [
                    _c("tr", [
                      _c("th", { attrs: { colspan: "2" } }),
                      _c("th", { staticClass: "text-right" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("currency")(_vm.transactionTotalValue)
                            ) +
                            " "
                        ),
                      ]),
                      _c("th", { attrs: { colspan: "2" } }),
                      _c("th", { attrs: { colspan: "2" } }),
                      _c("th", { staticClass: "text-right" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("currency")(_vm.erpTotalValue)) +
                            " "
                        ),
                      ]),
                      _c("th", { attrs: { colspan: "3" } }),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "b-row",
            { staticClass: "pt-1" },
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("e-pagination-summary", {
                    attrs: {
                      "current-page": _vm.paging.currentPage,
                      "per-page": _vm.paging.pageSize,
                      total: _vm.paging.rowCount,
                      "total-on-page": _vm.paging.rowsInCurrentPage,
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      align: "right",
                      "total-rows": _vm.paging.rowCount,
                      "per-page": _vm.paging.pageSize,
                      "aria-controls": "conciliation-items-table",
                    },
                    on: { change: _vm.pageChange },
                    model: {
                      value: _vm.paging.currentPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.paging, "currentPage", $$v)
                      },
                      expression: "paging.currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }